import { POST_FRAGMENT } from 'utils/queries';

import { gql } from '@apollo/client';

export const CREATE_POST_MUTATION = gql`
  mutation CreatePost(
    $discussionableId: ID!
    $title: String
    $body: BodyInput
    $content: String
    $spaceId: ID
    $attachments: [PostAttachmentInput!]
    $mentionedUserIds: [ID!]
  ) {
    createPost(
      input: {
        discussionableId: $discussionableId
        title: $title
        body: $body
        content: $content
        communitySpaceId: $spaceId
        attachments: $attachments
        mentionedUserIds: $mentionedUserIds
      }
    ) {
      post {
        id
      }
      userErrors {
        code
        message
      }
    }
  }
`;

export const EDIT_POST_MUTATION = gql`
  mutation EditPost(
    $input: EditPostInput!
    $numberOfReactions: Int = 7
    $multipleReactionsEnabled: Boolean = false
  ) {
    editPost(input: $input) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const DELETE_POST_MUTATION = gql`
  mutation DeletePost($id: ID!) {
    deletePost(input: { id: $id }) {
      userErrors {
        code
        message
      }
    }
  }
`;

export const MOVE_POST_MUTATION = gql`
  mutation MovePost(
    $id: ID!
    $communitySpaceId: ID!
    $multipleReactionsEnabled: Boolean = true
    $numberOfReactions: Int = 7
  ) {
    movePost(input: { id: $id, communitySpaceId: $communitySpaceId }) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const FOLLOW_POST_MUTATION = gql`
  mutation FollowPost(
    $id: ID!
    $numberOfReactions: Int = 7
    $multipleReactionsEnabled: Boolean = false
  ) {
    followPost(input: { id: $id }) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const UNFOLLOW_POST_MUTATION = gql`
  mutation UnfollowPost(
    $id: ID!
    $numberOfReactions: Int = 7
    $multipleReactionsEnabled: Boolean = false
  ) {
    unfollowPost(input: { id: $id }) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const PIN_POST_MUTATION = gql`
  mutation PinPost(
    $id: ID!
    $numberOfReactions: Int = 7
    $multipleReactionsEnabled: Boolean = false
  ) {
    pinPost(input: { id: $id }) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const UNPIN_POST_MUTATION = gql`
  mutation UnpinPost(
    $id: ID!
    $numberOfReactions: Int = 7
    $multipleReactionsEnabled: Boolean = false
  ) {
    unpinPost(input: { id: $id }) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;

export const TOGGLE_REACTION_ON_POST_MUTATION = gql`
  mutation ToggleReactionOnPost(
    $id: ID!
    $reactionType: PostReactionType!
    $numberOfReactions: Int = 7
    $multipleReactionsEnabled: Boolean = false
  ) {
    toggleReactionOnPost(input: { id: $id, reactionType: $reactionType }) {
      userErrors {
        code
        message
      }
      post {
        ...PostFields
      }
    }
  }
  ${POST_FRAGMENT}
`;
